import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const GreenCheckmarkGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('#66AE2D', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M1.33563 4.78158L3.89418 7.79474L8.69643 1.10868"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const GreenCheckmarkSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <GreenCheckmarkGroup {...props} />
    </svg>
  );
};
